import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import TeamMembers from './components/TeamMembers';

const OurTeamPage = () => {
  return (
    <div>
      <Helmet>
        <title>Our Team | Meet the Guidepost Pediatric Therapies Staff</title>
        <meta
          name="description"
          content="Meet the dedicated team of highly qualified pediatric therapy professionals at Guidepost in Wasilla, Alaska. Our specialists in PT, OT, and speech therapy are here to help your child."
        />
        <meta
          name="keywords"
          content="pediatric therapy team Wasilla, therapy staff Alaska, Guidepost team, pediatric therapists Wasilla"
        />
      </Helmet>
      <HeroSection />
      <TeamMembers />
    </div>
  );
};

export default OurTeamPage;
